import React from 'react'

import { Heading, Loader } from '@fourthwall/components'

import * as S from './UploadLoader.styled'

export const UploadLoader = () => {
  return (
    <S.Container>
      <Loader appearance="primary" size="large" />
      <Heading type="h4" weight="semibold">
        <S.HeadingText>Your file is being uploaded...</S.HeadingText>
      </Heading>
    </S.Container>
  )
}
